/**
 * MobileMyLists — Auth-gated grid of the user's food-related lists:
 * Donations, Wish List, Shopping List, Pantry List, Published
 * Products, and Groups. Guests see the AuthGateModal over the grid so
 * the tile layout is still visible behind the modal for context.
 */
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import AuthGateModal from "./AuthGateModal";
import { HeartHandshake, ClipboardList, ShoppingCart, Package, Store, Users } from "lucide-react";

const FP_PURPLE = "#653091";
const FP_GREEN = "#7BB325";

const TILES = [
  { key: "donation",   to: "/m/lists/donation",  title: "My Donation",           subtitle: null,                      Icon: HeartHandshake },
  { key: "wish",       to: "/m/lists/wish",      title: "My Wish List",          subtitle: "Add Your Favorite Items", Icon: ClipboardList },
  { key: "shopping",   to: "/m/lists/shopping",  title: "My Shopping List",      subtitle: "Manage Your Shopping",    Icon: ShoppingCart },
  { key: "pantry",     to: "/m/lists/pantry",    title: "My Pantry List",        subtitle: "Don't Let Food Expire!",  Icon: Package },
  { key: "published",  to: "/m/lists/published", title: "My Published Products", subtitle: "Live Listings",           Icon: Store },
  { key: "groups",     to: "/m/groups",          title: "My Groups",             subtitle: null,                      Icon: Users, spotlight: true },
];

function ListTile({ tile }) {
  return (
    <Link
      to={tile.to}
      data-testid={`mylists-tile-${tile.key}`}
      className="flex flex-col items-center justify-center bg-white rounded-2xl p-4 shadow-sm border transition-transform active:scale-95 min-h-[128px] text-center"
      style={{ borderColor: tile.spotlight ? "#1c1c1c" : "#eee", borderWidth: tile.spotlight ? 2 : 1 }}
    >
      <tile.Icon className="w-8 h-8 mb-2" style={{ color: FP_PURPLE }} />
      <div className="text-sm font-bold leading-tight">{tile.title}</div>
      {tile.subtitle && <div className="text-xs mt-1 text-gray-600 leading-snug">{tile.subtitle}</div>}
    </Link>
  );
}

export default function MobileMyLists() {
  const { user } = useAuth() || {};
  return (
    <div className="relative" data-testid="mobile-mylists">
      {/* Callout header */}
      <div className="px-5 pt-4 pb-3 text-center">
        <p className="text-sm font-semibold" style={{ color: FP_PURPLE }}>
          Your Food Lists. Your Privacy. Our Promise.
        </p>
        <p className="text-sm font-semibold" style={{ color: FP_PURPLE }}>
          Track Your Purchases and Manage Budget with Receipts
        </p>
      </div>

      <div className="px-4 pb-16 grid grid-cols-2 gap-3">
        {TILES.map((t) => (
          <ListTile key={t.key} tile={t} />
        ))}
      </div>

      {!user && <AuthGateModal />}
    </div>
  );
}
